
   import { Component, Vue } from "vue-property-decorator";
import ProductSelectSizeModal from "./ProductSelectSizeModal.vue";
   
   @Component({
    components: {
      ProductSelectSizeModal
    }
   })
   export default class ProductSelectSize extends Vue {
    
    public showProductSelectSizeModal: boolean = false;

    public handleCloseProductSelectSizeModal() {
      this.showProductSelectSizeModal = false;
    }
  }
   